export default function MagnifyingGlassIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <title>Search</title>
      <path
        d={'M10.113 16.198c3.36 0 6.085-2.724 6.085-6.085 0-3.36-2.724-6.085-6.085-6.085-3.36 0-6.085'
        + ' 2.725-6.085 6.085s2.725 6.085 6.085 6.085zm0 2.028C5.633 18.226 2 14.594 2 10.113 2 5.633 5.632 2 '
        + '10.113 2c4.48 0 8.113 3.632 8.113 8.113 0 4.48-3.632 8.113-8.113 8.113zM23 21.566L21.566 '
        + '23l-5.07-5.07 1.433-1.435L23 21.565z" transform="translate(-366 -120) translate(48 112) '
        + 'translate(318 8)'}
      />
    </svg>
  );
}
